import type { SVGProps } from 'react';

interface ChevronIconProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
export const ChevronIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & ChevronIconProps) => (
  <svg
    {...props}
    aria-labelledby={titleId}
    fill="none"
    height="1em"
    role="img"
    viewBox="0 0 24 24"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id={titleId}>{title}</title>
    <path
      d="M12.904 15.59c-.44.547-1.367.547-1.808 0L6.204 9.526C5.687 8.885 6.211 8 7.108 8h9.784c.897 0 1.42.885.904 1.526z"
      fill="#4FA9FF"
    />
  </svg>
);
